import { httpClient } from './http-client';
import type { DeviceLocationRequest, DeviceLocationResponse } from '../types';

/**
 * `POST|DELETE /api/auth/session/location` (ADR-43). Only the three numbers the
 * browser reported are sent; the API decides the place. Nothing is cached.
 */
export const deviceLocationService = {
  share(position: DeviceLocationRequest, signal?: AbortSignal): Promise<DeviceLocationResponse> {
    return httpClient.post<DeviceLocationResponse>('/auth/session/location', position, { signal });
  },

  clear(signal?: AbortSignal): Promise<void> {
    return httpClient.delete<void>('/auth/session/location', { signal });
  },
} as const;
